// ========= Tabs Product ========== //

document.addEventListener('DOMContentLoaded', () => {
  const tabs = Array.from(document.querySelectorAll('.container-tabs-product button'))
  const tabContent = Array.from(document.querySelectorAll('.formater-list-tabs'))

  if (!tabs.length || !tabContent.length) return

  tabs.forEach((tab, index) => {
    tab.addEventListener('click', event => {
      event.preventDefault()

      tabs.forEach(currentTab => {
        currentTab.classList.toggle('active', currentTab === tab)
      })

      tabContent.forEach((content, contentIndex) => {
        const active = index === contentIndex

        content.classList.toggle('active_description', active)
        content.classList.toggle('hidden_description', !active)
      })
    })
  })
})
